<template>
  <div class="dsfa-sc-common-tools">
    <DsfSCPanel title="常用功能" :more="true" :setting="true">
      <div class="dsfa-sc-common-tools-content">
        <div
          class="dsfa-sc-common-tools-block"
          v-for="(item, index) in list"
          :key="index"
          @click="toUrl(item)"
        >
          <div class="dsfa-sc-common-tools-block-content">
            <i
              :class="[
                'dsfa-sc-common-tools-block-content-icon',
                'icon',
                'iconfont',
                item.icon,
              ]"
            ></i>
            <div class="dsfa-sc-common-tools-block-content-text">
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>
    </DsfSCPanel>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfSCCommonTools",
  ctrlCaption: "常用功能",
  mixins: [$mixins.control],
  data() {
    return {
      list: [],
    };
  },
  components: {},
  created() {
    this.$http.get("/static/data/dsf.sccommontools.json").then(({ data }) => {
      this.list = data.dataList;
    });
  },
  methods: {
    toUrl({ url, openType }) {
      if (!url) return;
      this.$open({
        url,
        state: openType,
      });
    },
  },
});
</script>

<style lang="scss">
@import '_statistics-cloud/assets/styles/pc/commonTools.scss';
</style>